import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import BetaBanner from './components/BetaBanner';
import Home from './pages/Home';
import Pricing from './pages/Pricing';
import Reviews from './pages/Reviews';
import Admin from './pages/Admin';
import Users from './pages/Users';
import axios from 'axios';
import './App.css';

axios.defaults.withCredentials = true;

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
    
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('error')) {
      console.error('Auth error:', urlParams.get('error'));
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  useEffect(() => {
    const checkAuthAfterRedirect = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('openid.claimed_id') || urlParams.has('openid.identity') || urlParams.has('openid.mode')) {
        setTimeout(async () => {
          await checkAuth();
          window.history.replaceState({}, document.title, window.location.pathname);
        }, 500);
      }
    };
    checkAuthAfterRedirect();
  }, []);

  const checkAuth = async () => {
    try {
      const response = await axios.get('/api/auth/user');
      if (response.data && response.data.id) {
        setUser(response.data);
      } else {
        setUser(null);
      }
    } catch (error) {
      console.error('Auth check error:', error);
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      await axios.post('/api/auth/logout');
      setUser(null);
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  if (loading) {
    return <div className="loading">Загрузка...</div>;
  }

  return (
    <Router>
      <div className="app">
        <BetaBanner />
        <Header user={user} onLogout={handleLogout} />
        <Routes>
          <Route path="/" element={<Home user={user} />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/reviews" element={<Reviews user={user} />} />
          <Route 
            path="/admin" 
            element={user?.isAdmin ? <Admin user={user} /> : <Navigate to="/" />} 
          />
          <Route 
            path="/users" 
            element={user?.isAdmin ? <Users user={user} /> : <Navigate to="/" />} 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;

